import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { lotteryService, LotteryRound } from '../services/lotteryService'
import { isYeekeeRound } from './lottery-result'
import { LotteryResultSections } from './lottery-result'

const LotteryResultPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated } = useAuth()
  const [searchParams] = useSearchParams()
  const roundIdFromQuery = searchParams.get('roundId')
  const stateRound = (location.state as { round?: LotteryRound })?.round

  const [, setRound] = useState<LotteryRound | null>(stateRound || null)
  const [, setLoading] = useState(true)
  const [, setError] = useState<string | null>(null)
  const [selectedDate, setSelectedDate] = useState<string>(() => {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Bangkok',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formatter.format(new Date())
  })

  const targetRoundId = roundIdFromQuery || stateRound?._id

  useEffect(() => {
    if (!targetRoundId) {
      setRound(null)
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    setError(null)
    lotteryService
      .getLotteryRounds({ roundId: targetRoundId, limit: 1 })
      .then((list) => {
        const r = list?.[0] ?? null
        if (cancelled) return
        if (!r) {
          setRound(null)
          setError('ไม่พบข้อมูลรอบหวย')
          return
        }
        if (isYeekeeRound(r)) {
          navigate('/yeekee-result', { state: { round: r }, replace: true })
          return
        }
        setRound(r)
      })
      .catch(() => {
        if (!cancelled) {
          setRound(null)
          setError('โหลดข้อมูลไม่สำเร็จ')
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [targetRoundId, navigate])

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <Link to="/dashboard" className="txt-link-d">
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </Link>
                  </div>
                </div>

                <div className="col-12 px-1 mb-2">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-trophy me-2"></i>
                      ผลรางวัล
                    </div>
                    <div className="">
                      <div className="row mx--1">
                        <div className="col-8 px-1">
                          <div className="d-flex align-items-center w-100 h-100 px-2 bgc-15 bdr-5 bx-sd">
                            <span className="input-group-addon b-black c-white me-2">
                              <i className="fas fa-calendar-alt"></i>
                            </span>
                            <input
                              className="border-0 flex-grow-1 c-white bg-transparent"
                              type="date"
                              value={selectedDate}
                              onChange={(e) => setSelectedDate(e.target.value)}
                              style={{ minWidth: 0 }}
                            />
                          </div>
                        </div>
                        <div className="col-4 px-1">
                          <button
                            type="button"
                            className="check-button bgg-1 border-0 c-white w-100"
                          >
                            <p className="m-0">ตกลง</p>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <LotteryResultSections
                  selectedDate={selectedDate}
                  targetRoundId={targetRoundId}
                  onYeekeeRoundClick={
                    isAuthenticated ? (r) => navigate('/yeekee-result', { state: { round: r } }) : undefined
                  }
                  onYeekeeVipRoundClick={
                    isAuthenticated ? (r) => navigate('/yeekee-result', { state: { round: r } }) : undefined
                  }
                  showPoolError
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LotteryResultPage
